import { render, staticRenderFns } from "./EosVerificationInfo.vue?vue&type=template&id=45f6e3d4"
import script from "./EosVerificationInfo.vue?vue&type=script&lang=js"
export * from "./EosVerificationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports